import React from 'react'
import { Component } from 'react';
import Zitat from '../../../zitat_display/js/components/Zitat';
import ZitatAuszug from './ZitatAuszug';
import ZitatPopup from '../../../expert_search/js/components/ZitatPopup';
import ZitatAuszugLoading from './ZitatAuszugLoading';


const DEBOUNCE_TIMEOUT = 0

class StartseiteAuszug extends Component {

    constructor(props) {
        super(props);
        this.state = {
            waitingForResult: false,
            zitate_url: props.zitate_url,
            mode: props.mode == 'selected' ? 'selected' : props.mode == 'random' ? 'random' : 'latest',
            pks: props.pks || [],
            results: {},
        };

        this.sendRequest = _.debounce(
            this.sendRequestNow,
            DEBOUNCE_TIMEOUT
            //, {trailing: true, leading: false})();
        );
    }

    componentDidMount() {
        this.sendRequest();
    }

    sendRequestNow = () => {
        this.setState({ waitingForResult: true })
        const xhr = $.ajax({
            url: this.state.zitate_url,
            method: "GET",
            data: {mode: this.state.mode, pks: this.state.pks},
            dataType: "json",
            success: (data) => {
                data.waitingForResult = false;
                if (data.results.list && !this.state.pks.length)
                    data.results.list = data.results.list.sort(function(a,b){
                        return b.text_html.length- a.text_html.length
                    })
                this.setState(data);
            }
        });
    };

    onShowZitat = (pk) => {
        if (window.getSelection().toString()=="") {
            this.setState((state, props) => ({
                popup_pk: pk
            }));
        }
    };

    onHideZitat = () => {
        this.setState((state, props) => ({
            popup_pk: 0
        }));
    };

    render() {
        return (
            <div>
                {
                    this.state.waitingForResult || !this.state.results.list ?

                        <ZitatAuszugLoading />
                        : null
                }
                {this.state.results.list ?
                    <div className="grid-x">
                        <div className="grid-x">

                            <div className="small-8 large-8 cell grid-x">
                                <div className="small-12 large-12 cell mb">
                                    <ZitatAuszug
                                        className="stretch  mr"
                                        onClick={this.onShowZitat}
                                        {...this.state.results.list[0]}
                                    />
                                </div>
                                <div className="small-12 large-12 cell mb">
                                    <ZitatAuszug
                                        className="stretch  mr"
                                        onClick={this.onShowZitat}
                                        {...this.state.results.list[1]}
                                    />
                                </div>
                            </div>
                            <div className="small-4 large-4 cell mb">
                                <ZitatAuszug
                                    className="stretch"
                                    onClick={this.onShowZitat}
                                    {...this.state.results.list[2]}
                                />
                            </div>
                        </div>

                        <div className="grid-x">
                            <div className="small-6 large-6 cell">
                                <ZitatAuszug
                                    className="stretch  mr"
                                    onClick={this.onShowZitat}
                                    {...this.state.results.list[3]}
                                />
                            </div>
                            <div className="small-6 large-6 cell">
                                <ZitatAuszug
                                    className="stretch"
                                    onClick={this.onShowZitat}
                                    {...this.state.results.list[4]}
                                />
                            </div>
                        </div>
                    </div>
                    : null}
                {!this.state.popup_pk ? null :
                    <ZitatPopup
                        pk={this.state.popup_pk}
                        onClose={this.onHideZitat}
                        onChangeZitat={this.onShowZitat}
                    />
                }
            </div>
        );
    }
}

export default StartseiteAuszug;


// WEBPACK FOOTER //
// ./cms_plugins/startseite_auszug/js/components/StartseiteAuszug.js